import { forwardRef, Type } from '@angular/core';

import { BaseSelectDirective, WithSelectToken } from './base-select.directive';


/**
 * Creates provider that registers the component as base select directive.
 *
 * @param type type of the component
 * @return provider for the given type
 * */
export function selectProviderFactory<T extends BaseSelectDirective>(type: Type<T>) {
  return {
    provide: WithSelectToken,
    useExisting: forwardRef(() => type)
  };
}
